module.exports = false;



//////////////////
// WEBPACK FOOTER
// E:/R1/Angular/turnero/web-visor-cliente/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0